<template>
<div>
  <div class="speakerrelatedVideoContainer">
    <div class="headerText">{{$t('Related Videos')}}</div>
    <div
      class="speakerrelatedVideo"
      v-for="(relatedVideo, index) in data"
      :key="index"
      @click="relatedVideoClicked(relatedVideo.url)"
    >
      <div class="imgContainer">
            <div
      class="loadingContainer"
      :style="relatedVideo.imgSource == null ? 'display:flex' : 'display:none'"
    >
      <div class="loader"></div>
    </div>
        <img :src="relatedVideo.imgSource" :style="relatedVideo.imgSource == null ? 'display:none' : 'display:flex'"/>
      </div>
      <div class="textContainer">
        <div class="titleText">
          {{ relatedVideo.title }}
        </div>
        <div class="descriptionText">
          {{ relatedVideo.description }}
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import "../scss/relatedVideos.css";
import timeMixin from '../mixins/timeMixin'

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  created(){
    this.data.forEach(element => {
      element.parsedStart=this.convertHoursMinsSecsToSeconds(element.startTime)
      element.parsedEnd=this.convertHoursMinsSecsToSeconds(element.endTime)
    });
  },
  methods: {
    runFirstLoad(){
      },
    relatedVideoClicked(url) {
      window.location.replace(url);
    },
  },
  mixins:[timeMixin]
};
</script>
